
import { AuthenticationFailed, ConfiguratorPage, HomeApp, Welcome, Validating, Categories, Products, Cart, DetailedSearch, ModelConfiguratorPage, Configurator } from './site';
import {SupportOptions} from './site/components/navigation';
import { desanitize, getRouteToName } from './util';
import React, { Component } from 'react';
import { HashRouter as Router, Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { isTranslatorReady, translate,sessionStore } from './services';
import { PropTypes } from 'prop-types';
import { 
  analyticsDispatcher,
  combineStates, 
  identityState, 
  nodeState, 
  productsDispatcher, 
  repositoryState, 
  resourceState, 
  settingsState,
  siteSettingsState,
  combineDispatchers,
  showConfigureState,
  showConfigureDispatcher,
  screenSizeDispatcher,
  screenSizeState
} from './store';
import { EditConfiguration, FindConfiguration } from './components';
import { UserIdentity } from './util';
import { Helmet } from 'react-helmet';
import { ModelConfiguratorSelectorPage } from './site/components/screens/ModelConfiguratorSelectorPage';
import { initializeDataLayer } from './dataLayerScript.js';

function *findInPropertyPath( source, property, predicate ) {
  if ( predicate( source ) ) {
    yield source;
  }
  for ( let child of source[property] ) {
    let result = findInPropertyPath( child, property, predicate ).firstOrDefault();
    if ( result ) {
      yield result;
    }
  }
}

function sanitizeHashUrl( url ) {
  if ( url && url.charAt( 0 ) === '#' ) {
    url = url?.substring( 1 );
  }
  return url;
}

/*
 * @class AppRouterComponent
 * @type Extends the React.Component
 * Allows for dynamic routes based on state
 */
export class AppRouterComponent extends Component { 
  constructor() {
    super();
    this.state = {
      validated: false,
      landingpagecart: false
    };

    this.updateAnalytics = this.updateAnalytics.bind( this );
    this.renderConfigurator = this.renderConfigurator.bind( this );
    this.redirectToNonAuthorized = this.redirectToNonAuthorized.bind( this );
    this.redirectToLandingPage = this.redirectToLandingPage.bind( this );
    this.handleNodeCid = this.handleNodeCid.bind( this );
    this.redirectToDefaultLandingPage = this.redirectToDefaultLandingPage.bind( this );
    this.renderConfigurationRequest = this.renderConfigurationRequest.bind( this );
    this.openConfigurator = this.openConfigurator.bind( this );
    this.renderCart= this.renderCart.bind(this);
    this.updateLandingPage = this.updateLandingPage.bind(this);
  }

  componentDidMount(){
    this.props.resizeScreen();
  }
  componentDidUpdate( prevProps ) {
    if ( prevProps && prevProps.siteSettings && !prevProps.siteSettings.trackingId && this.props.siteSettings.trackingId ) {
      initializeDataLayer(this.props.siteSettings.properties?.iFrameScriptGA);
      this.props.initializeGA( this.props.siteSettings.trackingId[0] );
      if(this.props.siteSettings.trackingId.length > 1) this.props.initializeGACommon( this.props.siteSettings.trackingId[1] );
      this.updateAnalytics();
    }
  }

  redirectToNonAuthorized(err) {
    this.setState( {
      validated: true,
      authenticationFailed: true,
      message: err?.error
    } );
  }

  getLandingPage() {
    const { siteSettings } = this.props;
    return siteSettings && siteSettings.configuration && siteSettings.configuration.defaultLandingPage || '#/';
  }

  getPHLandingPage() {
    const { user } = this.props;
    const token = UserIdentity.token.split('?')[0];
    const configureURL = '#/configurationrequest/'.concat( token, '/configure' );
    return user.properties['IsConfigurationPage'] === "True" ? configureURL : this.getLandingPage();
  }

  getLandingPageForApttus = () => {
    const { siteSettings, user } = this.props;
    const token = UserIdentity.token.split('?')[0];
    var isNewApttusCall = ( user.properties["Action"] === "New" );
    //const landingPage = window.location.href.indexOf('/configuration/') ? '#/configurator/'+ user.properties["ProductType"] : "#/selector/" + user.properties["ProductType"];
    let landingPage;
    if(window.location.href.indexOf('/configuration/') > -1){
      landingPage = '#/configurator/'+ user.properties["ProductType"];
    }
    else if(user.properties.DirectLaunchPossible == "TRUE" && isNewApttusCall){
      landingPage = this.getLandingPage();
    }
    else{
      landingPage = "#/selector/" + user.properties["ProductType"];
    }
    const configureURL = '#/configurationrequest/'.concat( token, '/configure' );
    siteSettings.configuration.defaultLandingPage = landingPage;
    window.location.href = landingPage;
    if(user.properties['IsConfigurationPage'] === "True"){
      return configureURL;
    }
    /* if ( !isNewApttusCall ) {
      this.openConfigurator();
    }
    this.setState( { validated: true } ); */
    //return user.properties['IsConfigurationPage'] === "True" ? configureURL : landingPage;
    //return landingPage;
  }

  getLandingPageMethod(){
    const { user } = this.props;
    const IsPHCall = user.authenticationType === 'PartnerHub' || user.authenticationType === 'File';
    const isApttusCall = ( this.props.user.authenticationType === "Apttus" ) ? true : false;
    let landingPage;
    if(IsPHCall){
      landingPage = this.getPHLandingPage();
    }
    else if(isApttusCall){
      landingPage = this.getLandingPageForApttus();
    }
    else{
      landingPage = this.getLandingPage()
    }

    return landingPage;
  }

  redirectToLandingPage = () => {
    const { hash } = window.location;
    const { user } = this.props;
    const landingPage = this.getLandingPageMethod()

    if ( landingPage && ( user.properties['IsConfigurationPage'] === "True" || !hash || hash === '#/' ) ) {
      window.location.href = landingPage;
    }
    const buyNowParam=window.location.hash.split('?')[1]
    buyNowParam && sessionStore.set("BuyNowUTM",buyNowParam)
    if(window.location.href.indexOf('?')>-1){
      window.location.href=window.location.href.substring(0,window.location.href.indexOf('?'))
    }
    // this.props.getProductsInCart( user );
    if (hash.includes("#/cart")){
      this.setState( {landingpagecart:true } )     
    }
    this.setState( { validated: true } );
  }

  handleNodeCid( { match } ) {
    const { params } = match;
    const { cid } = params;
    const { node } = this.props;
    let targetUrl = this.getLandingPage();
    if ( cid ) {
      const selectedNode = findInPropertyPath( node, 'children', child => child.nodeId === cid ).firstOrDefault();
      if ( selectedNode ) {
        targetUrl = `${ getRouteToName( selectedNode ) }`;
      }
    }
    return <Redirect to={ sanitizeHashUrl( targetUrl ) } />;
  }

  renderConfigurator( { match } ) {
    const { node } = this.props;
    const searchId = desanitize( match.params.uid );
    const selected = findInPropertyPath( node, 'children', child => child.isConfigurator && ( child.uuid === searchId || child.nodeId === searchId ) ).firstOrDefault();
    const product = { name: selected.configuratorName };
    return <ModelConfiguratorPage product={ product } prefilters={ selected.preFilters }/>;
  }

  updateAnalytics( page ) {
    const { siteSettings } = this.props;

    this.props.showConfigure.show && this.props.leaveConfigurator()
    if( !page || !siteSettings || !siteSettings.trackingId || !siteSettings.applicationName ) {
      return;
    }
    
    let analyticsTitle;

    if( page.startsWith( '/' ) ) {
      const pageName = page.length === 1 ? 'Home' : page?.substring( 1 ).capitalize();
      document.title = `${translate( siteSettings.applicationName )}`;
      analyticsTitle = `${ pageName } | ${ siteSettings.applicationName }`;
    } else {
      const pagePath = page.split( '/' );
      document.title = `${translate( pagePath[pagePath.length - 1] ) } | ${translate( siteSettings.applicationName )}`;
      analyticsTitle = `${ page } | ${ siteSettings.applicationName }`;
    }
    // gtag('event', 'page_view', {
    //   page_title: document.title,
    //   page_location: window.location.href
    // });
   this.props.capturePageView( window.location.hash, ['commonTracker'], analyticsTitle );
   
    dataLayer.push({
      event: "page_view", 
      event_action: window.location.hash,
      event_label : analyticsTitle,
      event_instance:this.props.siteSettings.properties.GaInstance,
      event_country: this.props.siteSettings.properties.GaCountry,
      location_url:window.location.href
    })
    //saving in the sessionstore the visited urls
    //in order to retreive last url used in jiracomponent
    let history=sessionStore.get('history')?sessionStore.get('history'):[];
    history=[...history, dataLayer.filter((event)=>event.event==="page_view").map((e)=>e.location_url).slice(-1)[0]];
    history=history.filter(url=>!url?.includes("support"));
    sessionStore.set('history', history);
  }

  redirectToDefaultLandingPage() {
    const landingPage = this.getLandingPage();
    if(window.location.hash.includes('bom=')||window.location.hash.includes('supercode=')){
      return <FindConfiguration productId={window.location.hash}/>
    }
    if ( landingPage && landingPage !== '#/' ) {
      return <Redirect to={ sanitizeHashUrl( landingPage ) } />;
    }
    return <Welcome />;
  }

  openConfigurator() {
    return <EditConfiguration 
      hash={ UserIdentity.token }
      user = {this.props}
      defaultLandingPage={ sanitizeHashUrl( this.getLandingPage() ) }
    />;
  }

  renderConfigurationRequest( { match } ) {
    const { params, path } = match;
    const { cid } = params;
  
    if ( ( /^configure$/i ).test( cid ) ) {
      return <Route path={ path } exact render={ this.openConfigurator } />;
    }

    return <Route path={ path } render={ this.handleNodeCid } />;
  }

  renderLegacyConfigurationRequest ( { match } ) {
    const { params } = match;
    if(window.location.hash.includes('bom=')||window.location.hash.includes('supercode=')){
      return <FindConfiguration productId={window.location.hash}/>
    }
    const redirectionUrl = `/configurationrequest/${params.request}/${params.cid}`;
    return <Redirect to={ redirectionUrl }/>;
  }
  updateLandingPage(value){
    this.setState({landingpagecart:value})
  }
  renderCart(){ 
   return <Cart landingpagecart= {this.state.landingpagecart} updateLandingPage= {this.updateLandingPage} />
  }
  render() {
    const { settings, node, resources, siteSettings } = this.props;
    const { authenticationFailed, isLoadingConfiguration, validated , message} = this.state;

    if ( authenticationFailed ) {
      return <AuthenticationFailed  message = {message}/>;
    }

    if ( !this.props || !settings || !settings.auth || !node || !node.name || !resources || !resources.translations || !isTranslatorReady() || !validated ) {
      return <Validating onSuccess={ this.redirectToLandingPage } onFailed={ this.redirectToNonAuthorized }/>;
    }

    return <Router onUpdate={ this.updateAnalytics }>
      <Helmet>
        {/* <title>eConfigure Devices</title>  */}
        <meta property="og:title" content="eConfigure Devices"/>
        <meta property="og:type" content="website" />
        
        {/* <meta name='keywords' content='Circuit breakers, enclosed switches, switches, fusegear, switchgear, cables, enclosures, motor controllers, pilot devices, ...'/> */}
      </Helmet>
      <HomeApp updateGA={ this.updateAnalytics } isBusy={ isLoadingConfiguration } landingpagecart={this.state.landingpagecart}>
        <Route exact path="/" render={ this.redirectToDefaultLandingPage } />
        <Route path="/categories" component={ Categories } />
        <Route path="/selector" component={ Products } />
        <Route path="/configurator/:uid" render={ this.renderConfigurator } />
        <Route path="/reconfigure/:uid" render={ this.renderConfigurator } />
        <Route path="/cart"  render={ this.renderCart} />
        <Route path="/nodecid/:cid" render={ this.handleNodeCid } />
        <Route path="/partid/:cid" render={ this.handleNodeCid } />
        <Route path="/configurationrequest/:request/:cid?" render={ this.renderConfigurationRequest } />
        <Route path="/products/configurationrequest/:request/:cid?" render={ this.renderLegacyConfigurationRequest } />
        <Route path="/search/:query+" component={ DetailedSearch } />
        <Route path="/configuratorSelector" component={ ModelConfiguratorSelectorPage } />
        {siteSettings.configuration && siteSettings.configuration.navigationLinks.filter(link => link.translationKey === "Support" && link.isEnabled).length > 0 && (
        <Route path="/support" component={ SupportOptions } />
   )
}
      </HomeApp>
    </Router>;
  }
}

AppRouterComponent.propTypes = {
  capturePageView: PropTypes.func.isRequired,
  initializeGA: PropTypes.func.isRequired,
  node: PropTypes.shape( {
    name: PropTypes.string
  } ),
  resources: PropTypes.shape( {
    translations: PropTypes.arrayOf( 
      PropTypes.shape( { 
        culture: PropTypes.string.isRequired, 
        isDefault: PropTypes.bool.isRequired, 
        translations: PropTypes.shape( {} ).isRequired 
      } ) 
    )
  } ),
  settings: PropTypes.shape( {
    auth: PropTypes.string
  } ),
  siteSettings: PropTypes.shape( {
    applicationName: PropTypes.string.isRequired,
    trackingId: PropTypes.array
  } ),
  user: PropTypes.shape( {
    token: PropTypes.string,
    products: PropTypes.shape( {} )
  } ).isRequired
};

export const AppRouter = connect( 
  combineStates( identityState, settingsState, nodeState, siteSettingsState,screenSizeState, repositoryState( 'selectors' ), resourceState, showConfigureState ),
  combineDispatchers( analyticsDispatcher, productsDispatcher, showConfigureDispatcher, screenSizeDispatcher)
)( AppRouterComponent );